import React from 'react';
import { ComponentType } from 'react';
import { FormFieldProps } from '@components/form/Form/Form';
import classNames from 'classnames';
import AlertLabel from '@components/AlertLabel/AlertLabel';
import { useTheme } from '@context/themeContext';

type FieldWithLabelProps = {
    inline?: boolean;
    alertLabel?: string;
    visible?: boolean;
};

//eslint-disable-next-line
const withClass = <P extends {}>(Wrapped: ComponentType<P>, className: string) => {
    return (props: P) => (
        <div className={className}>
            <Wrapped {...props} />
        </div>
    );
};

const FieldWithLabel = <P extends FormFieldProps>(Wrapped: ComponentType<P>) => {
    return React.forwardRef<HTMLElement, P & FieldWithLabelProps>(
        ({ inline, label, alertLabel, visible = true, ...props }, ref) => {
            const { theme } = useTheme();

            const fieldGroupClassname = classNames(
                theme === 'light' ? 'light' : 'dark',
                'form-field-group',
                inline && 'inline',
                props.fieldGroupClassName && props.fieldGroupClassName
            );

            return (
                <>
                    {visible ? (
                        props.hidden ? (
                            <Wrapped {...(props as any)} ref={ref} />
                        ) : (
                            <label className={fieldGroupClassname}>
                                <div className="label-group">
                                    <span>{label ?? props.name}</span>
                                    <div className="alert_description">
                                        {props.required ? (
                                            <span className="asterisk">*</span>
                                        ) : null}
                                        {alertLabel && <AlertLabel text={alertLabel} />}
                                    </div>
                                </div>
                                <Wrapped {...(props as any)} ref={ref} />
                            </label>
                        )
                    ) : null}
                </>
            );
        }
    );
};

export { FieldWithLabel };
